/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';

/**
 * 
 */
export class StaticFileControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for predictorXgbThresholds without sending the request
     */
    async predictorXgbThresholdsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/static/predictor/xgb_thresholds.xlsx`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async predictorXgbThresholdsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const requestOptions = await this.predictorXgbThresholdsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async predictorXgbThresholds(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.predictorXgbThresholdsRaw(initOverrides);
        return await response.value();
    }

}
